import tcfd from "../../assets/svg/tcfd.svg";
import sdr from "../../assets/svg/sdr.svg";
import sfdr from "../../assets/svg/sfdr.svg";
import tnfd from "../../assets/svg/tnfd.svg";
import tcfdReportBg from "../../assets/images/tcfd_report_illustration.png";
import votingReportBg from "../../assets/images/voting_report_illustration.png";
import genericReportBg from "../../assets/images/generic_report_illustration.png";
import genericReport2Bg from "../../assets/images/generic_report_2_illustration.png";
import genericReport3Bg from "../../assets/images/generic_report_3_illustration.png";
import voting from "../../assets/svg/voting_black.svg";
import {
  TcfdRequestParams,
  DefaultRequestParams,
  StewardshipParams,
  StewardshipCodeParams,
  EngagementParams,
} from "../../models/reportModels";
import { MESSAGES } from "../../messages";
import { Filter as Option } from "../../types/PageFilterTypes";
import { ReportCategory } from "../../enums/Reports";

const genericBgs = [genericReportBg, genericReport3Bg, genericReport2Bg];

export const bgImages = [tcfdReportBg, votingReportBg, ...genericBgs];

export const reportsListDefaultItems: ReportItem[] = [
  {
    title: "TCFD",
    type: ReportCategory.TCFD,
    description: "Task Force on Climate-related Financial Disclosures",
    icon: tcfd,
    isActive: true,
    bg: tcfdReportBg,
    colorIndex: 0,
  },
  {
    title: "Voting",
    type: ReportCategory.STEWARDSHIP,
    description: "Voting Report",
    icon: voting,
    isActive: true,
    bg: votingReportBg,
    imagePadding: 20,
    colorIndex: 1,
  },
  {
    title: "Stewardship Code",
    type: ReportCategory.STEWARDSHIP_CODE,
    description: "Stewardship Code Report",
    icon: voting,
    isActive: true,
    bg: genericBgs[1],
    colorIndex: 3,
  },
  {
    title: "Engagement",
    type: ReportCategory.ENGAGEMENT,
    description: "Engagement Report",
    icon: voting,
    isActive: true,
    bg: genericBgs[2],
    colorIndex: 4,
  },
  {
    title: "SDR",
    type: ReportCategory.SDR,
    description: "Sustainability Disclosure Requirements",
    icon: sdr,
    isActive: false,
    bg: genericBgs[0],
    imagePadding: 40,
    colorIndex: 2,
  },
  {
    title: "SFDR",
    type: ReportCategory.SFDR,
    description: "Sustainable Finance Disclosure Regulation",
    icon: sfdr,
    isActive: false,
    bg: genericBgs[1],
    colorIndex: 3,
  },
  {
    title: "TNFD",
    type: ReportCategory.TNFD,
    description: "Task Force on Nature-related Financial Disclosures",
    icon: tnfd,
    isActive: false,
    bg: genericBgs[2],
    colorIndex: 4,
  },
  {
    title: "DLUHC",
    type: ReportCategory.DLUHC,
    description:
      "Department of Leveling Up, Housing and Communities Climate Disclosures",
    icon: tcfd,
    isActive: false,
    bg: genericBgs[0],
    imagePadding: 40,
    colorIndex: 2,
  },
  {
    title: "DWP Climate Disclosures",
    type: ReportCategory.DWP_Climate_Disclosures,
    description: "Department for Work and Pensions Climate Disclosures",
    icon: sdr,
    isActive: false,
    bg: genericBgs[1],
    colorIndex: 3,
  },
];

export const defaultReportItem: ReportItem = {
  title: "default",
  type: ReportCategory.TCFD,
  description: "default",
  icon: "default",
  isActive: false,
  requestParams: {
    default: "default",
  },
  allParamOptions: [
    [
      {
        key: "",
        displayValue: MESSAGES.LOADING_FILTERS,
        selectorName: "pLoading...",
      },
    ],
  ],
};

export type ReportItem = {
  title: string;
  type: ReportCategory;
  description: string;
  icon: string;
  isActive: boolean;
  requestParams?: TcfdRequestParams | StewardshipParams | StewardshipCodeParams | EngagementParams | DefaultRequestParams;
  allParamOptions?: Option[][];
  bg?: string;
  imagePadding?: number;
  colorIndex?: number;
};
